(function () {
  'use strict';

  var label = 'View product';

  if (window.wetheme && window.wetheme.global && window.wetheme.global.translations) {
    label = window.wetheme.global.translations.viewProduct || label;
  } else if (window.Theme && Theme.localization && Theme.localization.product) {
    label = Theme.localization.product.viewProduct || label;
  }

  var CARD_SELECTOR = [
    '#gf-products > article.product-item',
    '#gf-products > .spf-product-card',
    '[data-globo-filter-items] > article.product-item',
    '[data-globo-filter-items] > .spf-product-card',
    'article.product-item[data-product-item]',
    'article[data-product-item].product-item',
    '[data-product-item].product-item',
    '.spf-product-card'
  ].join(', ');

  var GRID_SELECTORS = [
    '#gf-products',
    '[data-globo-filter-items]',
    '.collection-main-wrapper',
    '.search-wrapper',
    '#CollectionProductGrid'
  ];

  var ATC_SELECTOR = [
    'button.spf-product__form-btn-addtocart',
    '.spf-product__form-btn-addtocart[type="submit"]',
    '[data-add-to-cart]',
    '.spf-add-to-cart',
    '.gspf-add-to-cart'
  ].join(', ');

  var GLOBO_EVENTS = [
    'globoFilterRendered',
    'globoFilterRenderCompleted',
    'globoFilterUpdated',
    'globo.filter.rendered',
    'globo.filter.render.completed'
  ];

  var initialized = false;
  var pollTimer = null;
  var pollAttempts = 0;

  function getGrids() {
    var grids = [];
    var seen = new Set();

    for (var i = 0; i < GRID_SELECTORS.length; i++) {
      document.querySelectorAll(GRID_SELECTORS[i]).forEach(function (node) {
        if (!seen.has(node)) {
          seen.add(node);
          grids.push(node);
        }
      });
    }

    return grids;
  }

  function getProductUrl(card) {
    var selectors = [
      '.product-item-title a[href*="/products/"]',
      '.spf-product-card__title a[href*="/products/"]',
      'h4 a[href*="/products/"]',
      'h3 a[href*="/products/"]',
      'a[href*="/products/"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var link = card.querySelector(selectors[i]);

      if (link && link.getAttribute('href')) {
        return link.getAttribute('href');
      }
    }

    return null;
  }

  function createViewLink(url) {
    var viewLink = document.createElement('a');
    viewLink.href = url;
    viewLink.className = 'ecc-collection-view-product collection-view-product';
    viewLink.setAttribute('data-view-product', '');
    viewLink.setAttribute('data-ecc-view-product', '');
    viewLink.textContent = label;
    return viewLink;
  }

  function ensureImageMount(imageNode) {
    if (!imageNode || !imageNode.parentNode) {
      return null;
    }

    if (imageNode.closest('.ecc-image-mount')) {
      return imageNode.closest('.ecc-image-mount');
    }

    if (imageNode.tagName === 'FIGURE') {
      if (!imageNode.style.position || imageNode.style.position === 'static') {
        imageNode.style.position = 'relative';
      }

      return imageNode;
    }

    var mount = document.createElement('div');
    mount.className = 'ecc-image-mount';
    mount.setAttribute('data-ecc-image-mount', '');

    imageNode.parentNode.insertBefore(mount, imageNode);
    mount.appendChild(imageNode);

    return mount;
  }

  function hideQuickView(card) {
    card.querySelectorAll('.open-quick-view, [onclick*="quickView"]').forEach(function (node) {
      node.remove();
    });
  }

  function removeAddToCart(card) {
    card.querySelectorAll(ATC_SELECTOR).forEach(function (button) {
      if (!button.classList.contains('collection-view-product') && !button.hasAttribute('data-ecc-view-product')) {
        button.remove();
      }
    });
  }

  function removeSecondaryPanel(card) {
    card.querySelectorAll('.product-item-details-secondary').forEach(function (node) {
      node.remove();
    });
  }

  function removePlainViewLinks(card) {
    card.querySelectorAll('.product-item-details-secondary > a, .product-item-details > a').forEach(function (link) {
      if (link.classList.contains('collection-view-product') || link.hasAttribute('data-ecc-view-product')) {
        return;
      }

      if (/view product/i.test((link.textContent || '').trim())) {
        link.remove();
      }
    });
  }

  function insertViewProduct(card, viewLink) {
    var wrap = document.createElement('div');
    wrap.className = 'collection-view-product-wrap';
    wrap.setAttribute('data-ecc-view-product-wrap', '');
    wrap.appendChild(viewLink);

    var imageNode = card.querySelector(
      'figure.product-item-image, .product-item-image, a.spf-product-card__image-wrapper, .spf-product-card__image-wrapper'
    );

    if (imageNode) {
      var mount = ensureImageMount(imageNode);

      if (mount) {
        mount.appendChild(wrap);
        return true;
      }
    }

    var inner = card.querySelector('.spf-product-card__inner, .product-item__wrapper');

    if (inner) {
      if (!inner.style.position || inner.style.position === 'static') {
        inner.style.position = 'relative';
      }

      inner.insertBefore(wrap, inner.firstChild);
      return true;
    }

    if (!card.style.position || card.style.position === 'static') {
      card.style.position = 'relative';
    }

    card.appendChild(wrap);
    return true;
  }

  var GRID_CONTAINER_SELECTORS = [
    '#gf-products',
    '#collection',
    '#template--collection',
    '[data-globo-filter-items]'
  ];

  function clampColumns(value, min, max, fallback) {
    var parsed = parseInt(value, 10);

    if (isNaN(parsed)) {
      return fallback;
    }

    return Math.min(max, Math.max(min, parsed));
  }

  function columnsFromGridClasses(classString) {
    var desktop = null;
    var mobile = null;

    if (!classString) {
      return { desktop: desktop, mobile: mobile };
    }

    if (classString.indexOf('large--one-half') >= 0) {
      desktop = 2;
    } else if (classString.indexOf('large--one-third') >= 0) {
      desktop = 3;
    } else if (classString.indexOf('large--one-quarter') >= 0) {
      desktop = 4;
    } else if (classString.indexOf('large--one-fifth') >= 0) {
      desktop = 5;
    } else if (classString.indexOf('large--one-sixth') >= 0) {
      desktop = 6;
    }

    if (classString.indexOf('small--one-whole') >= 0) {
      mobile = 1;
    } else if (classString.indexOf('small--one-half') >= 0) {
      mobile = 2;
    }

    return { desktop: desktop, mobile: mobile };
  }

  function readGridSettings(container) {
    var desktop = 3;
    var mobile = 2;
    var sources = [
      container,
      document.getElementById('template--collection'),
      document.getElementById('gf-products'),
      document.getElementById('collection'),
      document.getElementById('CollectionProductGrid')
    ];

    for (var i = 0; i < sources.length; i++) {
      var source = sources[i];

      if (!source) {
        continue;
      }

      if (source.hasAttribute('data-ecc-desktop-columns')) {
        desktop = clampColumns(source.getAttribute('data-ecc-desktop-columns'), 2, 6, desktop);
      }

      if (source.hasAttribute('data-ecc-mobile-columns')) {
        mobile = clampColumns(source.getAttribute('data-ecc-mobile-columns'), 1, 2, mobile);
      }

      var rawSettings = source.getAttribute('data-settings');

      if (rawSettings) {
        try {
          var settings = JSON.parse(rawSettings);

          if (settings['desktop-products-per-row'] != null) {
            desktop = clampColumns(settings['desktop-products-per-row'], 2, 6, desktop);
          } else if (settings.collectionProductsPerRow != null) {
            desktop = clampColumns(settings.collectionProductsPerRow, 2, 6, desktop);
          }

          if (settings['mobile-products-per-row'] != null) {
            mobile = clampColumns(settings['mobile-products-per-row'], 1, 2, mobile);
          } else if (settings.mobileProductsPerRow != null) {
            mobile = clampColumns(settings.mobileProductsPerRow, 1, 2, mobile);
          }
        } catch (error) {
          /* ignore invalid JSON */
        }
      }
    }

    var widthClasses = document.getElementById('grid_item_width_classes');

    if (widthClasses && widthClasses.value) {
      var fromClasses = columnsFromGridClasses(widthClasses.value);

      if (fromClasses.desktop != null) {
        desktop = fromClasses.desktop;
      }

      if (fromClasses.mobile != null) {
        mobile = fromClasses.mobile;
      }
    }

    return {
      desktop: desktop,
      mobile: mobile
    };
  }

  function getGridContainers() {
    var containers = [];
    var seen = new Set();

    for (var i = 0; i < GRID_CONTAINER_SELECTORS.length; i++) {
      document.querySelectorAll(GRID_CONTAINER_SELECTORS[i]).forEach(function (node) {
        if (seen.has(node)) {
          return;
        }

        if (!node.querySelector('article.product-item, .spf-product-card')) {
          return;
        }

        seen.add(node);
        containers.push(node);
      });
    }

    return containers;
  }

  function applyGloboGridColumns() {
    var containers = getGridContainers();

    if (!containers.length) {
      return false;
    }

    containers.forEach(function (container) {
      var columns = readGridSettings(container);

      container.style.setProperty('--ecc-globo-cols-mobile', String(columns.mobile));
      container.style.setProperty('--ecc-globo-cols-desktop', String(columns.desktop));
    });

    return true;
  }

  function ensureViewProduct(card) {
    hideQuickView(card);
    removeAddToCart(card);
    removeSecondaryPanel(card);
    removePlainViewLinks(card);

    if (card.querySelector('[data-ecc-view-product-wrap]')) {
      return true;
    }

    var url = getProductUrl(card);

    if (!url) {
      return false;
    }

    return insertViewProduct(card, createViewLink(url));
  }

  function refreshGrid(grid) {
    var cards = grid.querySelectorAll(CARD_SELECTOR);
    var updated = 0;

    for (var i = 0; i < cards.length; i++) {
      if (ensureViewProduct(cards[i])) {
        updated += 1;
      }
    }

    return updated;
  }

  function refreshAll() {
    var grids = getGrids();
    var updated = 0;

    if (!grids.length) {
      updated = refreshGrid(document.body);
    } else {
      for (var i = 0; i < grids.length; i++) {
        updated += refreshGrid(grids[i]);
      }
    }

    return updated;
  }

  function bindGrid(grid) {
    var updated = refreshGrid(grid);

    if (grid.getAttribute('data-ecc-view-product-bound') === 'true') {
      return updated;
    }

    grid.setAttribute('data-ecc-view-product-bound', 'true');

    new MutationObserver(function () {
      refreshGrid(grid);
    }).observe(grid, { childList: true, subtree: true });

    return updated;
  }

  function init() {
    applyGloboGridColumns();
    var grids = getGrids();

    if (!grids.length) {
      refreshAll();
      return;
    }

    for (var i = 0; i < grids.length; i++) {
      bindGrid(grids[i]);
    }
  }

  function scheduleInit() {
    init();

    if (refreshAll() > 0 && pollTimer) {
      window.clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  function startPolling() {
    if (pollTimer) {
      return;
    }

    pollTimer = window.setInterval(function () {
      pollAttempts += 1;
      scheduleInit();

      if (pollAttempts >= 60) {
        window.clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 500);
  }

  function boot() {
    if (initialized) {
      scheduleInit();
      return;
    }

    initialized = true;
    scheduleInit();
    startPolling();

    for (var i = 0; i < GLOBO_EVENTS.length; i++) {
      document.addEventListener(GLOBO_EVENTS[i], scheduleInit);
      window.addEventListener(GLOBO_EVENTS[i], scheduleInit);
    }

    document.addEventListener('shopify:section:load', scheduleInit);
    document.addEventListener('shopify:section:reorder', scheduleInit);

    if (window.MutationObserver) {
      new MutationObserver(function () {
        var gfProducts = document.getElementById('gf-products');

        if (gfProducts) {
          bindGrid(gfProducts);
        }

        document.querySelectorAll('[data-globo-filter-items]').forEach(function (grid) {
          bindGrid(grid);
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    var resyncTimer = null;
    var resyncAttempts = 0;

    resyncTimer = window.setInterval(function () {
      resyncAttempts += 1;
      scheduleInit();

      if (resyncAttempts >= 30) {
        window.clearInterval(resyncTimer);
        resyncTimer = null;
      }
    }, 2000);
  }

  window.eccRefreshCollectionGrid = scheduleInit;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
